import { movies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';
import MovieCard from './MovieCard';

const todayNotes = [
  { icon: 'ri-upload-cloud-2-line', title: '今日上架', desc: '当天新增与调整的影片集中在此，条目按热度与更新顺序排列。' },
  { icon: 'ri-calendar-line', title: '按天滚动', desc: '更新内容每天变化，想看「今天有什么可看」，从这里开始最省时间。' },
  { icon: 'ri-signal-tower-line', title: '动态提示', desc: '上映、下架与档期变动会同步反映到各分区的状态标签上。' },
];

export default function TodayUpdates() {
  const todayMovies = movies.filter((m) => m.isTodayUpdate);

  return (
    <section id="today" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <SectionHeading
            kicker="Daily Update"
            title="今日更新：当天值得先看的几部"
            desc="把当天新增与调整过的影片集中排在一起，用一句话说清看点，方便快速决定今晚看什么。"
          />
          <span className="inline-flex items-center gap-2 self-start md:self-end px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm whitespace-nowrap">
            <i className="ri-refresh-line animate-spin" style={{ animationDuration: '3s' }} />
            今日共 {todayMovies.length} 条更新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {todayMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {todayNotes.map((note) => (
            <div key={note.title} className="flex gap-3 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200">
              <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${note.icon} text-xl`} />
              </span>
              <div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900">{note.title}</h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{note.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}